import React from 'react'
import PaginatedListCard from '../common/PaginatedListCard'
import { Button } from 'reactstrap'

function DistributorsListCard({
  distributors,
  isLoading,
  error,
  onRefresh,
  onEdit,
  canEdit = true,
  page,
  totalPages,
  totalElements,
  size,
  onPageChange,
  onSizeChange,
}) {
  const safeDistributors = Array.isArray(distributors) ? distributors : []
  const columns = canEdit ? ['ID', 'Nombre', 'Acciones'] : ['ID', 'Nombre']
  const rows = safeDistributors.map((distributor) => ({
    key: distributor.id,
    cells: [
      distributor.id,
      distributor.name,
      ...(canEdit
        ? [
            <Button color="primary" size="sm" onClick={() => onEdit(distributor)}>
              Editar
            </Button>,
          ]
        : []),
    ],
  }))

  return (
    <PaginatedListCard
      title="Listado de distribuidores"
      isLoading={isLoading}
      error={error}
      onRefresh={onRefresh}
      emptyMessage="No hay distribuidores registrados."
      columns={columns}
      rows={rows}
      page={page}
      totalPages={totalPages}
      totalElements={totalElements}
      size={size}
      onPageChange={onPageChange}
      onSizeChange={onSizeChange}
      pageSizeId="distributor-page-size"
    />
  )
}

export default DistributorsListCard
